/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="m9.6834 1.345-.9736.0011h-.0003c-.2704-.0001-.4577-.2068-.4577-.423 0-.1879.1392-.3666.3542-.4123L8.7314.5h6.5584c.2706 0 .458.2068.458.423 0 .188-.1392.3667-.3542.4123l-.1251.0108-.9279-.0011-.5-.0006-.0006.5-.0082 7.0396-.0002.1762.1102.1374 7.5128 9.3606c.9966 1.4569.5924 3.422-.9316 4.401-.5479.3519-1.1935.5408-1.8554.5408H5.332C3.474 23.5 2 22.0534 2 20.3077c0-.6204.1888-1.2286.545-1.7495l3.9287-4.895 3.5841-4.4656.1096-.1366.0004-.1752.0162-7.0396.0012-.5018-.5018.0006Zm-2.9 13.0052h-.2406l-.1501.1881-3.4064 4.2673-.0106.0134-.0098.014c-.3034.4385-.4659.9526-.4659 1.4792 0 1.4154 1.144 2.5595 2.5755 2.6814l.0106.0009.0107.0005.214.0091.0106.0004h13.3462c.5641 0 1.1162-.1603 1.5851-.4615 1.2041-.7734 1.5923-2.2813.9179-3.4902l-.0059-.0106-.0064-.0103-.1115-.1788-.0154-.0247-.0181-.0228-3.4063-4.2673-.1501-.1881H6.7835Zm9.2356-.5h1.0388l-.6481-.8119-3.0784-3.8567.0087-7.678.0006-.4997-.4997-.0009L11.1849 1l-.4998-.001-.0011.4999-.0172 7.685L7.59 13.0382l-.648.8119h9.077Z"
  />,
  'Test'
);
